import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import PackagingProductNewEditForm from '../packaging-product-new-edit-form';

export default function PackagingProductCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new product"
        links={[
          {
            name: 'Products',
            href: paths.dashboard.packagingProduct.root,
          },
          { name: 'Create a new product' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <PackagingProductNewEditForm />
    </Container>
  );
}
